function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if ( !customElements.get('quantity-selector') ) {
	class QuantityInput extends HTMLElement  {
	  constructor() {
			super();
	    this.input = this.querySelector('.qty');
	    this.changeEvent = new Event('change', {
	      bubbles: true
	    });
	    // Create buttons
	    this.subtract = this.querySelector('.minus');
	    this.add = this.querySelector('.plus');

	    // Add functionality to buttons
	    this.subtract.addEventListener('click', () => this.change_quantity(-1));
	    this.add.addEventListener('click', () => this.change_quantity(1));

	  }
		connectedCallback() {
			this.classList.add('buttons_added');
		}
	  change_quantity(change) {
	    // Get current value
	    let quantity = Number(this.input.value);

	    // Ensure quantity is a valid number
	    if (isNaN(quantity)) quantity = 1;

	    // Change quantity
	    quantity += change;

	    // Ensure quantity is always a number
	    quantity = Math.max(quantity, 1);

	    // Output number
	    this.input.value = quantity;

	    this.input.dispatchEvent(this.changeEvent);
	  }
	}
	customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function VariantSelector
 */
if (!customElements.get('variant-selector')) {
	class VariantSelector extends HTMLElement {
		constructor() {
			super();

			this.select = this.querySelector('select');

			this.select.addEventListener('change', (e) => this.onChange(e));
		}

		onChange(e) {
			this.select.dispatchEvent(new CustomEvent('variant-change', {
				detail: {
					value: this.select.value
				}
			}));
		}
	}

	customElements.define('variant-selector', VariantSelector);
}


/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
		this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
			this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
	class ProductCard extends HTMLElement {
		constructor() {
	    super();
			this.swatches = this.querySelector('.product-card-swatches');
	    this.image = this.querySelector('.product-featured-image-link .product-primary-image');
	    this.additional_images = this.querySelectorAll('.product-secondary-image');
			this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
	    this.quickview_button = this.querySelector('.product-card-quickview');
		}
		connectedCallback() {
			if (this.swatches) {
	      this.enableSwatches(this.swatches, this.image);
	    }
	    if (this.quickview_button) {
	      this.enableQuickview(this.quickview_button);
	    }
			if (this.additional_images) {
	      this.enableAdditionalImages();
	    }
		}
		enableAdditionalImages() {
			let image_length = this.additional_images.length;
			let images = this.additional_images;
			let nav = this.additional_images_nav;
			let image_container = this.querySelector('.product-featured-image');
			let startX;
			let startY;

			const mousemove = function(e) {
				let l = e.offsetX;
	      let w = this.getBoundingClientRect().width;
	      let prc = l/w;
	      let sel = Math.floor(prc*image_length);
	      let selimg = images[sel];
				images.forEach((image, index) => {
					if ( image.classList.contains('hover') ) {
						image.classList.remove('hover');
						if ( nav.length ) {
							nav[index].classList.remove('active');
						}
					}
				});
				if ( selimg ) {
					if ( ! selimg.classList.contains('hover')) {
			      selimg.classList.add('hover');
						if ( nav.length ) {
							nav[sel].classList.add('active');
						}
					}
				}
			};

			const mouseleave = function(e) {
				images.forEach((image, index) => {
					image.classList.remove('hover');
					if ( nav.length ) {
						nav[index].classList.remove('active');
					}
				});
			};

			const touchstart = (e) => {
				var touchObj = e.changedTouches[0];

				startX = touchObj.pageX;
				startY = touchObj.pageY;
			}

			const touchend = function(e) {
				var touchObj = e.changedTouches[0];
				var endX = touchObj.pageX;
				var endY = touchObj.pageY;

				const diffX = startX - endX;
				const diffY = startY - endY;

				if (Math.abs(diffX) > Math.abs(diffY)) {
					const imageCount = image_length + 1; // for the primary image
					const hoverIndex = Array.from(images).findIndex((image) => image.classList.contains('hover'));
					const activeIndex = hoverIndex === -1 ? 0 : hoverIndex + 1;
					const nextIndex = activeIndex + 1 < imageCount ? activeIndex + 1 : 0;

					images.forEach((image) => image.classList.remove('default-hover'));

					images.forEach((image, index) => {
						if (index + 1 === nextIndex) {
							image.classList.add('hover');
						} else {
							image.classList.remove('hover');
						}
						if (nav.length) {
							nav.forEach((navItem) => navItem.classList.remove('active'));
							nav[nextIndex].classList.add('active');
						}
					});
				}
			};

			if ( image_container ) {
				image_container.addEventListener( 'touchstart', touchstart, { passive: true } );
				// image_container.addEventListener( 'touchmove', mousemove, { passive: true } );
				image_container.addEventListener( 'touchend', touchend, { passive: true } );
				image_container.addEventListener( 'mouseenter', mousemove, { passive: true } );
				image_container.addEventListener( 'mousemove', mousemove, { passive: true } );
				image_container.addEventListener( 'mouseleave', mouseleave, { passive: true } );
			}

		}
		enableSwatches(swatches, image) {
	    let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
					org_srcset = image ? image.dataset.srcset : '',
		      active = swatches.querySelector('.product-card-swatch.active');

	    swatch_list.forEach((swatch, index) => {

	      swatch.addEventListener('mouseover', function() {

	        [].forEach.call(swatch_list, function(el) {
	          el.classList.remove('active');
	        });
					if ( image ) {
						if ( swatch.dataset.srcset  ) {
		          image.setAttribute('srcset', swatch.dataset.srcset);
						} else {
							image.setAttribute('srcset', org_srcset);
						}
	        }

	        swatch.classList.add('active');
	      });
	      swatch.addEventListener('click', function(evt) {
	        window.location.href = this.dataset.href;
	        evt.preventDefault();
	      });
	    });
	  }
	  enableQuickview(quickview_button) {
	    const _this = this,
	      drawer = document.getElementById('Product-Drawer'),
	      body = document.body;

			quickview_button.addEventListener('click', function(evt) {
	      evt.preventDefault();
	      let productHandle = quickview_button.dataset.productHandle,
	        	href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

	      // remove double `/` in case shop might have /en or language in URL
	      href = href.replace('//', '/');
	      if (!href || !productHandle) {
	        return;
	      }
	      if (quickview_button.classList.contains('loading')) {
	        return;
	      }
	      quickview_button.classList.add('loading');
	      fetch(href, {
	          method: 'GET'
	        })
	        .then((response) => {
	          quickview_button.classList.remove('loading');
	          return response.text();
	        })
	        .then(text => {
	          const sectionInnerHTML = new DOMParser()
	            .parseFromString(text, 'text/html')
	            .querySelector('#Product-Drawer-Content').innerHTML;
	          _this.renderQuickview(sectionInnerHTML, drawer, body, href, productHandle);

	        });
	    });
	  }
	  renderQuickview(sectionInnerHTML, drawer, body, href, productHandle) {
	    if (sectionInnerHTML) {
	      drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
	      let quantity = drawer.querySelector('.quantity:not(.buttons_added)');

	      setTimeout(() => {
	        if (Shopify && Shopify.PaymentButton) {
	          Shopify.PaymentButton.init();
	        }
	      }, 300);
				document.documentElement.classList.add('overflow-hidden');
	      body.classList.add('open-cc');
				body.classList.add('open-quick-view');
	      drawer.classList.add('active');
				setTimeout(() => {
		      drawer.querySelector('.product-quick-images--container').classList.add('active');
		    });
				drawer.querySelector('.side-panel-close').focus();
				dispatchCustomEvent('quick-view:open', {
					productUrl: href,
					productHandle: productHandle
				});
	    }
	  }
	}
	customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
		const header = document.getElementById('header'),
					header_main = document.getElementById("header"),
					setHeaderOffset = this.setHeaderOffset,
					setAnnouncementHeight = this.setAnnouncementHeight,
					setHeaderHeight = this.setHeaderHeight;

		if ( ! header_main ) {
			return;
		}

		// Sticky Header Class
		const updateSticky = function() {
			if ( window.scrollY > 0 ) {
				header_main.classList.add("is-sticky");
			} else {
				header_main.classList.remove("is-sticky");
			}
		};

		// Mobile Menu offset
		window.addEventListener('scroll', function() {
			updateSticky();
			setHeaderOffset(header);
			setHeaderHeight(header_main);
		}, { passive: true });
		window.dispatchEvent( new Event('scroll') );

		if ( document.getElementById('shopify-section-announcement-bar') ) {
			const a_bar = document.getElementById('shopify-section-announcement-bar');
			window.addEventListener('resize', function() {
				setAnnouncementHeight(a_bar);
			}, { passive: true } );
			window.dispatchEvent( new Event('resize') );
		}
  }
	setAnnouncementHeight(a_bar) {
		let h = a_bar.clientHeight;
		document.documentElement.style.setProperty('--announcement-height', h + 'px');
	}
	setHeaderOffset(header) {
		let h = header.getBoundingClientRect().top;
		document.documentElement.style.setProperty('--header-offset', h + 'px');
	}
	setHeaderHeight(header) {
		let h = header.clientHeight;
		document.documentElement.style.setProperty('--header-height', h + 'px');
	}
}

if (!customElements.get('mobile-menu-drawer')) {
	class MobileMenuDrawer extends HTMLElement {
		constructor() {
			super();
			this.dialog = this.querySelector('dialog');
			this.toggle = this.dialog
				? document.querySelector('[aria-controls="' + this.dialog.id + '"]')
				: null;
			this.panels = this.querySelectorAll('.mobile-menu-panel');
			this.bar = this.querySelector('.mobile-menu-dialog__bar');
			this.backBtn = this.querySelector('[data-panel-back]');
			this.titleEl = this.querySelector('[data-panel-title]');
			this.header = document.getElementById('header');
			this.stack = ['root'];
		}

		connectedCallback() {
			if (!this.dialog) return;

			// The header hamburger toggles the drawer (it morphs to ✕ when open).
			if (this.toggle) {
				this.toggle.addEventListener('click', () =>
					this.dialog.open ? this.close() : this.open()
				);
			}

			this.dialog.addEventListener('click', (event) => {
				const opener = event.target.closest('[data-panel-target]');
				if (opener && this.contains(opener)) {
					event.preventDefault();
					this.openPanel(opener.getAttribute('data-panel-target'), opener);
				}
			});

			if (this.backBtn) {
				this.backBtn.addEventListener('click', () => this.back());
			}

			document.addEventListener('keydown', (event) => {
				if (event.key === 'Escape' && this.dialog.open) this.close();
			});

			this.dialog.addEventListener('close', () => this.onClosed());

			this.resetPanels();
		}

		open() {
			if (this.dialog.open) return;
			this.resetPanels();
			this.positionBelowHeader();
			this.dialog.show();
			document.documentElement.classList.add('overflow-hidden');
			this.setBackgroundInert(true);
			if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
		}

		close() {
			if (!this.dialog.open) return;
			this.dialog.close(); // fires 'close' -> onClosed()
		}

		onClosed() {
			document.documentElement.classList.remove('overflow-hidden');
			this.setBackgroundInert(false);
			if (this.toggle) {
				this.toggle.setAttribute('aria-expanded', 'false');
				this.toggle.focus();
			}
		}

		positionBelowHeader() {
			const top = this.header ? this.header.getBoundingClientRect().bottom : 0;
			document.documentElement.style.setProperty('--mobile-menu-top', Math.max(0, top) + 'px');
		}

		setBackgroundInert(on) {
			const wrapper = document.getElementById('wrapper');
			if (!wrapper) return;
			if (on) {
				this._inerted = [];
				let reachedMain = false;
				Array.from(wrapper.children).forEach((el) => {
					if (el.id === 'main-content') reachedMain = true;
					if (!reachedMain) return;
					if (el.contains(this.dialog)) return;
					if (el.classList.contains('side-panel') || el.querySelector('.side-panel')) return;
					if (el.classList.contains('click-capture')) return;
					el.inert = true;
					this._inerted.push(el);
				});
			} else if (this._inerted) {
				this._inerted.forEach((el) => { el.inert = false; });
				this._inerted = null;
			}
		}

		openPanel(id, opener) {
			const panel = this.querySelector('.mobile-menu-panel[data-panel="' + id + '"]');
			if (!panel) return;
			panel._opener = opener || null;
			panel.classList.add('is-open');
			this.stack.push(id);
			this.setActive(panel);
			if (this.backBtn) this.backBtn.focus();
		}

		back() {
			if (this.stack.length <= 1) return;
			const leavingId = this.stack.pop();
			const leaving = this.querySelector('.mobile-menu-panel[data-panel="' + leavingId + '"]');
			const opener = leaving ? leaving._opener : null;
			if (leaving) leaving.classList.remove('is-open');
			const parent = this.querySelector('.mobile-menu-panel[data-panel="' + this.stack[this.stack.length - 1] + '"]');
			this.setActive(parent);
			if (opener && typeof opener.focus === 'function') opener.focus();
		}

		setActive(panel) {
			if (!panel) return;
			this.panels.forEach((p) => {
				const isActive = p === panel;
				p.classList.toggle('is-active', isActive);
				p.inert = !isActive;
			});
			const isRoot = panel.getAttribute('data-panel') === 'root';
			if (this.bar) this.bar.hidden = isRoot;
			if (this.titleEl) {
				this.titleEl.textContent = isRoot ? '' : (panel.getAttribute('data-title') || '');
			}
		}

		resetPanels() {
			this.stack = ['root'];
			this.panels.forEach((p) => {
				const isRoot = p.getAttribute('data-panel') === 'root';
				p.classList.toggle('is-open', isRoot);
				p.classList.toggle('is-active', isRoot);
				p.inert = !isRoot;
				p._opener = null;
			});
			if (this.bar) this.bar.hidden = true;
			if (this.titleEl) this.titleEl.textContent = '';
		}
	}
	customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
	class FullMenu extends HTMLElement {
		constructor() {
	    super();

			this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
		}
		connectedCallback() {
			if (!this.submenus.length) {
				return;
			}
			const _this = this;
			// resize on initial load
			document.fonts.ready.then(function() {
				window.addEventListener('resize', debounce(function() {
					_this.resizeSubMenus();
				}, 100));
			});

		}
		resizeSubMenus() {
			this.submenus.forEach((submenu) => {
				let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

				sub_submenus.forEach((sub_submenu) => {
					let w = sub_submenu.offsetWidth,
							l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
							total = w + l;

					if ( total > window.innerWidth) {
						sub_submenu.parentElement.classList.add('left-submenu');
					} else if ( sub_submenu.parentElement.classList.contains('left-submenu') ) {
						sub_submenu.parentElement.classList.remove('left-submenu');
					}
				});
			});
		}
	}
	customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
	class PanelClose extends HTMLElement {

	  constructor() {
			super();

		let cc = document.querySelector('.click-capture');

		// Add event listener for Enter key
		this.addEventListener('keydown', (e) => {
			if (e.code === 'Enter' || e.key === 'Enter') {
				this.close_panel(e);
			}
		});

		// Add functionality to buttons
		this.addEventListener('click', (e) => this.close_panel(e));
	    document.addEventListener('panel:close', (e) => {
				let panel = document.querySelectorAll('.side-panel.active');
				if (panel) {
					this.close_panel(e, panel[0]);
				}
	    });
	    cc.addEventListener('click', (e) => {
				let panel = document.querySelectorAll('.side-panel.active');
				if (panel) {
					this.close_panel(e, panel[0]);
				}
	    });

			document.addEventListener('cart-drawer:close', (e) => {
				let panel = document.querySelectorAll('.side-panel.active');
				if (panel) {
					this.close_panel(e, panel[0]);
				}
			});
	  }

	  close_panel(e, panel) {
			if ( e ) {
				e.preventDefault();
			}
			setTimeout(() => {
				document.documentElement.classList.remove('overflow-hidden');
			}, 800);

			if ( ! panel ) {
				panel = e.target.closest('.side-panel');

				if ( ! panel ) {
					return;
				}
			}
			if ( panel.classList.contains('product-drawer')) {
				this.close_quick_view(panel);
			} else if ( panel.classList.contains('cart-drawer') ) {
				if ( panel.querySelector('.product-recommendations--full') ) {
					if ( ! document.body.classList.contains('open-quick-view')) {
						panel.querySelector('.product-recommendations--full').classList.remove('active');
					}
				}
				if ( window.innerWidth < 1069 ) {
					if ( ! document.body.classList.contains('open-quick-view')) {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
						document.body.classList.remove('open-cart');
					} else {
						this.close_quick_view();
					}
				} else {
					if ( panel.querySelector('.product-recommendations--full') ) {
						if (! document.body.classList.contains('open-quick-view')) {
							setTimeout(() => {
								panel.classList.remove('active');
								document.body.classList.remove('open-cc');
								document.body.classList.remove('open-cart');
							}, 500);
						} else {
							this.close_quick_view();
						}
					} else {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
						document.body.classList.remove('open-cart');
					}
				}
			} else {
				panel.classList.remove('active');
				document.body.classList.remove('open-cc');
			}
			
			const backdrop = document.querySelector('.side-panel-backdrop');
			if ( backdrop ) {
				backdrop.classList.remove('active');
			}
	  }
		close_quick_view( panel ) {
			panel = panel ? panel : document.getElementById('Product-Drawer');

			if ( panel.querySelector('.product-quick-images--container') ) {
				panel.querySelector('.product-quick-images--container').classList.remove('active');
			}
			if ( window.innerWidth < 1069 ) {
				panel.classList.remove('active');
				if ( ! document.body.classList.contains('open-cart') ) {
					document.body.classList.remove('open-cc');
				}
				document.body.classList.remove('open-quick-view');
			} else {
        console.log("🦜 close_quick_view panel HERE 2");
				if ( panel.querySelector('.product-quick-images--container') ) {
					setTimeout(() => {
						panel.classList.remove('active');
						if ( ! document.body.classList.contains('open-cart') ) {
							document.body.classList.remove('open-cc');
						}
						document.body.classList.remove('open-quick-view');
					}, 500);
				}
			}

      dispatchCustomEvent('quick-view:close');
		}
	}
	customElements.define('side-panel-close', PanelClose);

	document.addEventListener('keydown', (e) => {
		if (e.code.toUpperCase() === 'ESCAPE') {
			dispatchCustomEvent('panel:close');
		}
	});
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.documentElement.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.documentElement.classList.remove('overflow-hidden');
    this.removeAttribute('open');
		this.querySelectorAll('.js-youtube').forEach((video) => {
	    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	  });
	  this.querySelectorAll('.js-vimeo').forEach((video) => {
	    video.contentWindow.postMessage('{"method":"pause"}', '*');
	  });
		this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
			localization.addEventListener("change", (e) => {
				localization.querySelector('form').submit();
			});
		});
	}
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
		let _this = this;
		// resize on initial load
		window.addEventListener('load', () => {
			document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
		});

		// delegated listener on change
		document.body.addEventListener('change', (e) => {
	    if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
	       _this.resizeSelect(e.target);
	    }
		});
		window.addEventListener('resize.resize-select', function() {
			document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
		});
	}

	resizeSelect(sel) {
	  let tempOption = document.createElement('option');

	  if(sel.selectedOptions.length > 0) {
		  tempOption.textContent = sel.selectedOptions[0].textContent;

		  let tempSelect = document.createElement('select'),
			  offset = 12;
		  tempSelect.style.visibility = "hidden";
		  tempSelect.style.position = "fixed";
		  tempSelect.appendChild(tempOption);
		  if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code')) {
			  offset = 1;
		  }
		  sel.after(tempSelect);
		  if ( tempSelect.clientWidth > 0 ) {
			  sel.style.width = `${+tempSelect.clientWidth + offset}px`;
		  }
		  tempSelect.remove();
	  }

	}
}

if (typeof SelectWidth !== 'undefined') {
	new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
			button.addEventListener("click", (e) => {
		    button.classList.toggle('active');
			});
		});
	}
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
	class SidePanelContentTabs extends HTMLElement {
		constructor() {
	    super();
			this.buttons = this.querySelectorAll('button');
			this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
	  }
		connectedCallback() {
			this.setupButtonObservers();
		}
		disconnectedCallback() {

		}
		setupButtonObservers() {
			this.buttons.forEach((item, i) => {
				item.addEventListener('click', (e) => {
					this.toggleActiveClass(i);
				});
			});
		}
		toggleActiveClass(i) {
			this.buttons.forEach((button) => {
				button.classList.remove('tab-active');
			});
			this.buttons[i].classList.add('tab-active');

			this.panels.forEach((panel) => {
				panel.classList.remove('tab-active');
			});
			this.panels[i].classList.add('tab-active');
		}
	}

	customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
	class CollapsibleRow extends HTMLElement {
		constructor() {
	    super();

			this.details = this.querySelector('details');
    	this.summary = this.querySelector('summary');
    	this.content = this.querySelector('.collapsible__content');
		}
		connectedCallback() {
			this.setListeners();
		}
		setListeners() {
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				setTimeout(() => {
					this.prepareAnimations();
					this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
				}, 400);
			}
	  }
		prepareAnimations() {
			let _this = this,
					summary_height = this.querySelector('summary').offsetHeight,
					content_height = this.querySelector('.collapsible__content').offsetHeight,
					initial_height = summary_height,
					final_height = summary_height + content_height;

			this.tl = false;
			this.tl = gsap.timeline({
				reversed: !_this.details.open,
				paused: true,
				inherit: false,
				ease: 'sine.inOut',
				onStart: function() {
					_this.details.open = true;
					_this.details.style.overflow = 'hidden';
				},
				onReverseComplete: function() {
					_this.details.open = false;
					_this.details.style.overflow = '';
				}
			});

			this.tl
				.fromTo(_this.details, { height: function() {
					let h = Math.max( Math.max(initial_height, 0), 24 );
					return h;
				}, clearProps: 'height' }, { duration: 0.6, height: final_height, clearProps: 'height' });

			if ( this.details.open ) {
				this.tl.progress(1);
			}
		}
		instantClose() {
			this.tl.timeScale(10).reverse();
		}
		animateClose() {
			this.tl.timeScale(3).reverse();
		}
		animateOpen() {
			this.tl.timeScale(1).play();
		}
		onClick(e) {
			e.preventDefault();
			if ( this.tl.reversed() ) {
				this.tl.timeScale(1).play();
			} else {
				this.tl.timeScale(3).reverse();
			}
	  }
	}
	customElements.define('collapsible-row', CollapsibleRow);
}

window.addEventListener('load', () => {

	if (typeof Localization !== 'undefined') {
		new Localization();
	}
	if (typeof Header !== 'undefined') {
	  new Header();
	}
	if (typeof FooterMenuToggle !== 'undefined') {
		new FooterMenuToggle();
	}
});
